import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ArrowRight } from "lucide-react";

export default function FAQPreview({ faqs }) {
  return (
    <section className="py-24 bg-section-tint" data-testid="faq-preview-section">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <span className="text-xs tracking-[0.2em] uppercase font-semibold text-brandblue-600">Frequently Asked Questions</span>
          <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight font-medium text-slate-900 font-display">Common Research Questions</h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.slice(0, 5).map((faq) => (
            <AccordionItem key={faq.id} value={faq.id} className="border border-slate-200 rounded-2xl px-5 bg-white hover:border-blue-200 hover:shadow-blue-glow-sm transition-all duration-300" data-testid={`faq-item-${faq.id}`}>
              <AccordionTrigger className="text-sm font-semibold text-slate-900 hover:text-brandblue-700 hover:no-underline">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-sm text-slate-600 leading-relaxed">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="text-center mt-10">
          <Link to="/faq" className="inline-flex items-center text-sm font-semibold text-brandblue-600" data-testid="view-all-faqs-link">
            View All FAQs <ArrowRight className="h-4 w-4 ml-1.5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
